import { type StackProps, Text, VStack } from '@chakra-ui/react';
import { AGENTFUN_TAX } from '@cronos-app/sdk';
import { Num } from '@ui/components/Num';
import { useTokenConfig } from '@ui/hooks/contracts/useTokenConfig';
import { Fraction } from 'bi-fraction';

import { useH2SwapDialog } from '../../useH2SwapDialog';
import { H2BuySellToggle } from './H2BuySellToggle';
import { useH2SwapForm } from './useH2SwapForm';
import { useToTokenAmount } from './useToTokenAmount';

export const H2SwapExchangeRate = (props: StackProps) => {
  const fromToken = useH2SwapForm((s) => s.fromToken);
  const toToken = useH2SwapForm((s) => s.toToken);
  const formEnteredAmount = useH2SwapForm((s) => s.enteredAmount);
  const enteredAmount = formEnteredAmount.gt(0)
    ? formEnteredAmount
    : Fraction.ONE;
  const toTokenAmount = useToTokenAmount(enteredAmount);
  const exchangeRate = toTokenAmount
    ? toTokenAmount.div(enteredAmount)
    : undefined;
  const agentTokenAddress = useH2SwapDialog((s) => s.agentTokenAddress);

  const fromTokenInfo = useTokenConfig({
    token: fromToken,
    tokenAddress: agentTokenAddress,
  });
  const toTokenInfo = useTokenConfig({
    token: toToken,
    tokenAddress: agentTokenAddress,
  });

  return (
    <>
      <VStack gap={0} justifyContent="center" cursor="pointer" {...props}>
        <H2BuySellToggle />
        <Num
          mt="4px"
          prefix={`1 ${fromTokenInfo?.symbol} ≈ `}
          value={exchangeRate}
          suffix={toTokenInfo?.symbol}
          decimalPlaces={8}
          textStyle="body3"
          minWidth="200px"
        />
        <Text textStyle="body3">(Includes {AGENTFUN_TAX * 100}% fee)</Text>
      </VStack>
    </>
  );
};
